// 금천아 빌려줘 — 수령 완료(직접 수령·반납) 중단 표시 (목록 카드·상세 공용)
//
// 서버 handover = {needed, steps:[{key,label,done}], error}.
// 지난 시도가 중간에 멈췄을 때(error)만 보인다 — 어느 단계까지 됐는지 ✓/✗로 보여주고,
// 같은 "수령 완료" 버튼을 다시 누르면 서버가 남은 단계부터 이어서 한다.
import React from "react";

export default function HandoverProgress({ handover, oneline = false }) {
  if (!handover?.needed || !handover.error) return null;
  const firstPending = handover.steps.findIndex((step) => !step.done);
  return (
    <div className={`rental-warn-box rental-handover${oneline ? " rental-warn-box--oneline" : ""}`}>
      <strong>⚠ 수령 완료 중단 — 다시 누르면 남은 단계부터 이어서 합니다</strong>
      <div className="rental-handover-steps">
        {handover.steps.map((step, index) => (
          <span
            key={step.key}
            className={`rental-handover-step rental-handover-step--${
              step.done ? "done" : index === firstPending ? "failed" : "pending"
            }`}
          >
            {step.done ? "✓" : index === firstPending ? "✗" : "–"} {step.label}
          </span>
        ))}
      </div>
      {!oneline && <div className="rental-warn-reason">{handover.error}</div>}
    </div>
  );
}
